"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredDatasheetWorkflowStatus = exports.WorkFlowStatus = void 0;
const zod_1 = require("zod");
const identifier_1 = require("./identifier");
exports.WorkFlowStatus = zod_1.z.enum(["running", "complete", "failed", "unknown"]);
/**
 * Defines schema for the datasheet workflow status for datashee we store in GCS
 */
exports.StoredDatasheetWorkflowStatus = zod_1.z.object({
    status: exports.WorkFlowStatus,
    workflowName: zod_1.z.enum(["extract-orderable-mpns", "infer-data-from-datasheet"]),
    workflowId: zod_1.z.string(),
    firestoreUserHandle: zod_1.z.string(),
    firestoreOrganizationUid: zod_1.z.preprocess((v) => v ?? undefined, zod_1.z.optional(identifier_1.OrganizationUid)),
});
//# sourceMappingURL=workflow.js.map